import { useNavigate } from 'react-router-dom';
import useReveal from '@/hooks/useReveal';
import shared from '@/styles/public.module.css';
import styles from './HomeFaqSection.module.css';

// The five that come up first. The full set lives on /faq.
const QUESTIONS = [
  {
    q: 'What happens if I lose my case?',
    a: "You keep the money and repay nothing. That's what non-recourse means, and it's the reason this costs more than a bank loan — the funder is taking the risk that your case doesn't win.",
  },
  {
    q: 'Will this hurt my credit?',
    a: "No. There's no credit check to apply and nothing is reported to credit bureaus. Your score isn't used to decide anything.",
  },
  {
    q: 'Does my attorney have to agree?',
    a: "Your attorney has to confirm the case and sign an acknowledgment, because repayment comes out of the settlement they'll be distributing. They don't guarantee anything or take on any liability.",
  },
  {
    q: 'How much can I get?',
    a: 'Funders typically advance a modest share of what your case is expected to settle for, so it depends on the case. Most requests fall between $1,000 and $25,000, and you can request more than once as the case goes on.',
  },
  {
    q: 'How long does it take?',
    a: 'The slowest part is usually attorney verification. Once your attorney confirms the case, funders can review it and respond quickly.',
  },
];

const HomeFaqSection = () => {
  const navigate = useNavigate();
  const ref = useReveal(shared.rv, shared.revealed);

  return (
    <section
      id="faq"
      className={shared.section}
      ref={ref}
      data-testid="home-faq-section"
    >
      <div className={styles.wrap}>
        <div className={`${shared.secHead} ${styles.head} ${shared.rv}`}>
          <span className={shared.eyebrow}>Questions</span>
          <h2>The things people actually ask</h2>
        </div>

        <div className={shared.rv}>
          {QUESTIONS.map((item, i) => (
            <details key={item.q} className={styles.item} open={i === 0}>
              <summary className={styles.summary}>{item.q}</summary>
              <p className={styles.answer}>{item.a}</p>
            </details>
          ))}

          <div className={styles.more}>
            <button
              type="button"
              className={`${shared.btn} ${shared.btnQuiet}`}
              onClick={() => navigate('/faq')}
              data-testid="home-faq-all-btn"
            >
              Read all the questions
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFaqSection;
